<div class="search">
  <div class="serach-input">
    <img src="assets/images/icons/search.svg" alt="" />
  </div>

  <p-autoComplete
    class="search-input"
    [(ngModel)]="value"
    [suggestions]="selectedType !== 'service provider' ? items : []"
    (completeMethod)="search($event)"
    [placeholder]="!placeholderType ? 'search' : 'search '"
    (onSelect)="goSearchFilter()"
    (keyup.enter)="goSearchFilter()"
  >
  </p-autoComplete>

  @if (value) {
    <i class="pi pi-times clear-icon" (click)="clearInput()"></i>
  }

  <div class="menu">
    <p-dropdown [options]="types" [(ngModel)]="selectedType" />
  </div>
</div>
